/**
 * Machine-readable error codes carried in 400 bodies of the projects API.
 * The UI maps these to speaking, field-level messages — matching on the code
 * keeps that mapping stable when the human-readable message wording changes.
 */
export const PROJECT_ERROR_CODES = {
  /** A project with the same number already exists. */
  duplicateNumber: 'projects/duplicate-number',
  /** Assigning this parent would make the project its own ancestor. */
  parentCycle: 'projects/parent-cycle',
  /** An activity type with the same name already exists (case-insensitive). */
  duplicateActivityTypeName: 'projects/duplicate-activity-type-name',
  /** A cost rate already exists for this scope (global default, project default, or project × activity type). */
  duplicateCostRate: 'projects/duplicate-cost-rate',
  /** No global default cost rate is configured yet, so the rate hierarchy cannot resolve a fallback. */
  missingGlobalCostRate: 'projects/missing-global-cost-rate',
  /** A time entry is already approved and can no longer be changed through the booking endpoints. */
  entryApproved: 'projects/entry-approved',
  /** One or more requested entry ids are not eligible for the requested approve/unapprove transition. */
  entriesNotEligible: 'projects/entries-not-eligible',
  /** One or more entry ids referenced by an invoice line are no longer approved, billable, or not-yet-invoiced. */
  invoiceEntriesNotEligible: 'projects/invoice-entries-not-eligible',
  /** The same time entry id is referenced by more than one line of the same invoice. */
  invoiceEntryDuplicate: 'projects/invoice-entry-duplicate',
  /** PDF regeneration was requested for an invoice whose PDF already succeeded or is still in flight. */
  invoicePdfNotEligibleForRegenerate: 'projects/invoice-pdf-not-eligible-for-regenerate',
} as const;

export type ProjectErrorCode = (typeof PROJECT_ERROR_CODES)[keyof typeof PROJECT_ERROR_CODES];
